var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":require("@/assets/icons/equals5_icon.png"),"alt":"equals5 icon"}})
}
var staticRenderFns = []

export { render, staticRenderFns }